import { useRouter } from 'next/router';
import { useCallback } from 'react';

const useAddQuery = () => {
  const router = useRouter();

  const addQuery = useCallback((newQuery: Record<string, string | number>) => {
    // 获取现有的查询参数
    const currentQuery = { ...router.query };

    // 合并现有的查询参数和新的查询参数
    const updatedQuery = { ...currentQuery, ...newQuery };

    // 更新 URL 并保持页面状态
    router.push(
      {
        pathname: router.pathname,
        query: updatedQuery,
      },
      undefined,
      { shallow: true }
    );
  }, []);

  return addQuery;
};

export { useAddQuery };
